import { render, staticRenderFns } from "./ModalExclusaoUser.vue?vue&type=template&id=eab31e86&"
import script from "./ModalExclusaoUser.vue?vue&type=script&lang=js&"
export * from "./ModalExclusaoUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports